import { TextSectionTextTransformer } from "../rich-text-sections/base-text-section.component";

export class ReplaceParametersTextTransformer implements TextSectionTextTransformer {
  constructor(private replacementParametersMapAccessor: () => { [key: string]: string }) { }
  transformText(text: string): string {
    const replacementParameters = this.replacementParametersMapAccessor() || {};
    for (const k in replacementParameters) {
      const v = replacementParameters[k];
      text = text.replace(k, v);
    }
    return text;
  }
}

export class ReplaceTokenisedSimpleParametersTextTransformer implements TextSectionTextTransformer {
  constructor(private replacementParametersMapAccessor: () => { [key: string]: string }) { }
  transformText(text: string): string {
    const replacementParameters = this.replacementParametersMapAccessor() || {};
    for (const k in replacementParameters) {
      const v = replacementParameters[k];
      const token = '%{' + k + '}';
      while (text.indexOf(token) >= 0) {
        text = text.replace(token, v);
      }
    }
    return text;
  }
}

export class ReplaceTokenisedDynamicParametersTextTransformer implements TextSectionTextTransformer {
  constructor(private replacementParametersMapAccessor: () => { [key: string]: string }) { }
  transformText(text: string): string {

    if (text == null) {
      return "";
    }
    const replacements = this.replacementParametersMapAccessor() || {};
    if (replacements == null) {
      return text;
    }
    const dynamicReplacements = {};

    for (const paramTokenTemplate in replacements) {

      const replacementTemplate = replacements[paramTokenTemplate];
      if (paramTokenTemplate != null && replacementTemplate != null) {

        if (paramTokenTemplate.indexOf('|') >= 0) {
          var paramArgs = paramTokenTemplate.split("|");
          const paramName = paramArgs[0];
          paramArgs = paramArgs.slice(1);

          // Example: An image processing token with key=value in the "replacements" map
          // as:
          // "image|imageUrl"="<img src="%{imageUrl}"/>"
          // Now we have paramName = "image"
          // paramArgs = ["imageUrl"]
          // text = "......%{image|https://system.com/assets/image.png}
          // So we need to find "%{image" and the ending "}",
          // and we need to iterate through the text because there could be more
          // %{image|...} tokens

          // while loop is processing each occurrence of the dynamic token
          var textProcessStartIndex = 0;
          const paramTokenStart = '%{' + paramName + '|';
          const paramTokenEnd = '}';
          var indexOfTokenStart = text.indexOf(paramTokenStart, textProcessStartIndex);
          while (indexOfTokenStart >= 0) {

            //

            var indexOfTokenArgsStart = indexOfTokenStart + paramTokenStart.length;
            var indexOfTokenEnd = text.indexOf(paramTokenEnd, indexOfTokenArgsStart);
            var actualArgumentsText = text.substring(indexOfTokenArgsStart, indexOfTokenEnd);
            var actualArguments = actualArgumentsText.split("|");

            var tokenWithArgsTokenized = paramName;
            var argReplacements = {};
            for (let i = 0; i < paramArgs.length; i++) {
              const arg = paramArgs[i];
              const argValue = actualArguments[i];
              const simpleArgToken = '%{' + arg + '}';
              tokenWithArgsTokenized += ("|" + simpleArgToken);
              argReplacements[arg] = argValue;
            }

            const argReplacer = new ReplaceTokenisedSimpleParametersTextTransformer(() => argReplacements);
            const tokenWithArgsReplaced = argReplacer.transformText(tokenWithArgsTokenized);
            const replacementsWithArgsReplaced = argReplacer.transformText(replacementTemplate);

            dynamicReplacements[tokenWithArgsReplaced] = replacementsWithArgsReplaced;

            // update textProcessStartIndex to find next occurrence of the dynamic token
            indexOfTokenStart = text.indexOf(paramTokenStart, textProcessStartIndex);
            indexOfTokenArgsStart = indexOfTokenStart + paramTokenStart.length;
            indexOfTokenEnd = text.indexOf(paramTokenEnd, indexOfTokenArgsStart);
            textProcessStartIndex = indexOfTokenEnd;
          }
        }
      }
    }
    const argReplacer = new ReplaceTokenisedSimpleParametersTextTransformer(() => dynamicReplacements);
    text = argReplacer.transformText(text);

    return text;
  }
}


export class ReplaceTokenisedParametersTextTransformer implements TextSectionTextTransformer {
  private simpleTransformer: ReplaceTokenisedSimpleParametersTextTransformer;
  private dynamicTransformer: ReplaceTokenisedDynamicParametersTextTransformer;
  constructor(private replacementParametersMapAccessor: () => { [key: string]: string }) {
    this.simpleTransformer = new ReplaceTokenisedSimpleParametersTextTransformer(this.replacementParametersMapAccessor);
    this.dynamicTransformer = new ReplaceTokenisedDynamicParametersTextTransformer(this.replacementParametersMapAccessor);
  }
  transformText(text: string): string {
    text = this.simpleTransformer.transformText(text);
    text = this.dynamicTransformer.transformText(text);
    return text;
  }
}
